"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLAGS_ICONS = exports.FlagIcons = void 0;

var FlagIcons =
/** @class */
function () {
  function FlagIcons() {}

  FlagIcons.prototype.get = function (flag) {
    return "/img/flags/" + flag + ".svg";
  };

  return FlagIcons;
}();

exports.FlagIcons = FlagIcons;
exports.FLAGS_ICONS = new FlagIcons();